import * as R from "ramda";
import { validateObject, validateField } from "util/validation";

const projectDetailsConstraints = {
  projectName: {
    presence: {
      allowEmpty: false,
      message: "^Project Name must not be blank.",
    },
  },
  projectKey: {
    length: {
      maximum: 63,
      message: "^Project Key maximum length is %{count} characters.",
    },
    presence: {
      allowEmpty: false,
      message: "^Project Key must not be blank.",
    },
  },
};

const projectEmailConstraints = {
  emailTemplate: {
    presence: {
      allowEmpty: false,
      message: "^Email Template must not be blank.",
    },
  },
  emailSubject: {
    presence: {
      allowEmpty: false,
      message: "^Email Subject must not be blank.",
    },
  },
  emailFromAddress: {
    email: {
      message: "^From Address should be a valid email address.",
    },
  },
};

const projectLandingPageConstraints = {
  landingPageTemplate: {
    presence: {
      allowEmpty: false,
      message: "^Landing Page Template must not be blank.",
    },
  },
  thankYouPageTemplate: {
    presence: {
      allowEmpty: false,
      message: "^Thank You Page Template must not be blank.",
    },
  },
  projectDescription: {
    presence: {
      allowEmpty: false,
      message: "^About this Project must not be blank.",
    },
  },
  additionalInformation: {
    presence: {
      allowEmpty: false,
      message: "^Additional Information must not be blank.",
    },
  },
};

const socialLinkConstraints = {
  socialLinkPlatform: {
    presence: {
      allowEmpty: false,
      message: "^Social Link Platform must not be blank.",
    },
  },

  socialLinkUrl: {
    presence: {
      allowEmpty: false,
      message: "^Social Link URL must not be blank.",
    },
  },
};

const emailAddressConstraints = {
  emailAddress: {
    presence: {
      allowEmpty: false,
      message: "^Email Address must not be blank.",
    },
    email: {
      message: "^Email Address is not valid.",
    },
  },
};

const ripEndpointConstraints = {
  ripEndpoint: {
    presence: {
      allowEmpty: false,
      message: "^RIP Endpoint must not be blank.",
    },
  },

  ripEndpointId: {
    presence: {
      allowEmpty: false,
      message: "^RIP Endpoint Id must not be blank.",
    },
  },
};

export const validateProjectDetailsField = (field, value, errors = {}) =>
  validateField(projectDetailsConstraints, field, value, errors);

export const validateProjectDetails = R.partial(validateObject, [
  projectDetailsConstraints,
]);

export const validateProjectEmailField = (field, value, errors = {}) =>
  validateField(projectEmailConstraints, field, value, errors);

export const validateProjectEmail = R.partial(validateObject, [
  projectEmailConstraints,
]);

export const validateEmailAddressField = (field, value, errors = {}) =>
  validateField(emailAddressConstraints, field, value, errors);

export const validateEmailAddress = R.partial(validateObject, [
  emailAddressConstraints,
]);

export const validateLandingPageField = (field, value, errors = {}) =>
  validateField(projectLandingPageConstraints, field, value, errors);

export const validateLandingPage = R.partial(validateObject, [
  projectLandingPageConstraints,
]);

export const validateSocialLink = R.partial(validateObject, [
  socialLinkConstraints,
]);

export const validateRipEndpointField = (field, value, errors = {}) =>
  validateField(ripEndpointConstraints, field, value, errors);

export const validateRipEndpoint = R.partial(validateObject, [
  ripEndpointConstraints,
]);
